import Highcharts from 'highcharts/es-modules/masters/highstock.src.js';
import { legendDblClick } from '../common/plugins/highcharts/legend-dblclick';
import { zoneColor } from '../common/plugins/highcharts/zone-color';
import { ContextMenu } from '../common/plugins/highcharts/context-menu';
import { highchartsRegression } from '../common/plugins/highcharts/highcharts-regression';
import { ParetoChart } from '../common/plugins/highcharts/pareto-chart';
import { getTimeZoneOffset } from '@thoughtspot/date-format-util';
import { getSessionTimeZone } from '@thoughtspot/session-service';
import { PointDoubleClick } from '../common/plugins/highcharts/point-double-click';
import 'highcharts/es-modules/masters/highcharts-more.src.js';
import 'highcharts/es-modules/masters/modules/accessibility.src.js';
import 'highcharts/es-modules/masters/modules/exporting.src.js';
import 'highcharts/es-modules/masters/modules/funnel.src.js';
import 'highcharts/es-modules/masters/modules/heatmap.src.js';
import 'highcharts/es-modules/masters/modules/treemap.src.js';
import { highchartsOnloadCustomHandler } from '../common/plugins/highcharts/highcharts-onload-custom-handler';
import { highchartsTooltipDelay } from '../common/plugins/highcharts/tooltip-delay';
export const HCChart = Highcharts.Chart;
let isHCDecorated = false;
export const getHighchartsObject = () => {
    if (!isHCDecorated) {
        highchartsOnloadCustomHandler(Highcharts);
        legendDblClick(Highcharts);
        PointDoubleClick(Highcharts);
        zoneColor(Highcharts);
        ContextMenu(Highcharts);
        ParetoChart(Highcharts);
        highchartsRegression(Highcharts);
        highchartsTooltipDelay(Highcharts);
    }
    isHCDecorated = true;
    Highcharts.AST.allowedAttributes.push('data-tooltip-content');
    return Highcharts;
};
export function setHighchartsAccessibilityLang(getTranslatedText) {
    Highcharts.setOptions({
        lang: {
            accessibility: getTranslatedText('accessibility'),
        },
    });
}
export function setHighchartsTimezone() {
    const timezone = getSessionTimeZone();
    const globalHighchartsOptions = {
        useUTC: false,
        getTimezoneOffset(timestamp) {
            return -getTimeZoneOffset(timestamp, undefined, true);
        },
    };
    if (timezone) {
        globalHighchartsOptions.useUTC = true;
        globalHighchartsOptions.timezoneOffset = 0;
    }
    Highcharts.setOptions({
        global: globalHighchartsOptions,
    });
}
//# sourceMappingURL=highchart-init.js.map